import { Link } from "react-router-dom";
import { MessageCircle, Mail, MapPin } from "lucide-react";
import { NAV_LINKS, CONTACT } from "@/data/site";
import { LogoMark } from "@/components/Logo";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-abyss2">
    <div className="mx-auto max-w-[1440px] px-6 pt-24 lg:px-12">
      <div className="grid grid-cols-1 gap-12 border-b border-white/10 pb-16 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <LogoMark className="h-8 w-8 text-gold" />
            <span className="font-serif text-lg uppercase tracking-[0.18em] text-ivory">
              Velierul <span className="text-gold">Hope</span>
            </span>
          </div>
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-mist">
            Charter premium cu velierul Jeanneau Sun Odyssey 42.2 „Hope" pe
            Marea Neagră. Evenimente, cursuri și călătorii care rămân în memorie.
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-gold">Experiențe</p>
          <ul className="mt-6 space-y-3">
            {NAV_LINKS.slice(1, 9).map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  data-testid={`footer-${link.testid}`}
                  className="text-sm text-ivory/70 transition-colors hover:text-gold"
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-gold">Contact</p>
          <ul className="mt-6 space-y-4 text-sm text-ivory/70">
            <li>
              <a
                href={CONTACT.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-phone-link"
                className="flex items-center gap-3 transition-colors hover:text-gold"
              >
                <MessageCircle className="h-4 w-4 text-gold" /> {CONTACT.phone}
              </a>
            </li>
            <li>
              <a
                href={CONTACT.emailHref}
                data-testid="footer-email-link"
                className="flex items-center gap-3 transition-colors hover:text-gold"
              >
                <Mail className="h-4 w-4 text-gold" /> {CONTACT.email}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="h-4 w-4 text-gold" /> {CONTACT.location}
            </li>
          </ul>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-x-6 gap-y-2 py-6 text-xs text-mist">
        <Link to="/politica-confidentialitate" data-testid="footer-link-privacy" className="transition-colors hover:text-gold">
          Politica de Confidențialitate
        </Link>
        <Link to="/politica-cookies" data-testid="footer-link-cookies" className="transition-colors hover:text-gold">
          Politica de Cookies
        </Link>
        <Link to="/termeni-conditii" data-testid="footer-link-terms" className="transition-colors hover:text-gold">
          Termeni și Condiții
        </Link>
        <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer" data-testid="footer-link-anpc-sal" className="transition-colors hover:text-gold">
          ANPC — SAL
        </a>
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" data-testid="footer-link-anpc-sol" className="transition-colors hover:text-gold">
          ANPC — SOL
        </a>
      </div>

      <div className="flex flex-col items-center justify-between gap-4 border-t border-white/10 py-8 text-xs text-mist sm:flex-row">
        <p>© 2026 Velierul Hope. Toate drepturile rezervate.</p>
        <p className="uppercase tracking-[0.25em]">Limanu — Marea Neagră</p>
      </div>
    </div>

    <div
      aria-hidden="true"
      className="pointer-events-none select-none whitespace-nowrap text-center font-serif text-[13.5vw] leading-[0.8] tracking-tight text-white/[0.04]"
    >
      VELIERUL HOPE
    </div>
  </footer>
);
